import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SelectItem } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ProjectDetailsService {

    baseURL = environment.baseApiUrl;
    public httpClient: HttpClient;
    constructor(_httpClient: HttpClient) {
        this.httpClient = _httpClient;
  }
  
  getAllProjectDetails() {
        return this.httpClient.get<any>(this.baseURL + 'Project/GetAllProjectDetails'); 
  }

    getProjectDetailsRisk(projectId: number = 0) {
        return this.httpClient.get<any>(this.baseURL + 'Project/GetProjectDetailsRisk?projectId=' + projectId);
    }
 
    getProjectDetails(projectId: number = 0) {
        return this.httpClient.get<any>(this.baseURL + 'Project/GetProjectDetails?projectId=' + projectId);
    }
 
    getAllProjects(startDate: string, endDate: string) {
        return this.httpClient.get<any>(this.baseURL + 'Project/GetAllProjects?startDate='+ startDate + '&endDate=' + endDate);
    }
 
    addProjectDetails(projectDetails:any)
    {
      return this.httpClient.post<any>(this.baseURL + 'Project/CreateOrUpdateProjectDetails', projectDetails);
    }
 
    getAllProjectStatus() {
      var status: SelectItem[] = [
        { label: 'Low', value: '1' },
        { label: 'Medium', value: '2' },
        { label: 'High', value: '3' },
      ];
      return status;
  }
  
  getProjectById(projectId: number) {
    return this.httpClient.get<any>(this.baseURL + 'Project/GetProject?projectId=' + projectId);
  }
 
    createOrUpdateProjectDetailsRisks(projectDetailsRisk: any){
      return this.httpClient.post<any>(this.baseURL + 'Project/CreateOrUpdateProjectDetailsRisks', projectDetailsRisk)
  }
  
  getMilestones(projectId: number) {
    return this.httpClient.get<any>(this.baseURL + 'Project/GetMilestones?projectId=' + projectId);
  }

  createMilestones(milestone: any) {    
    return this.httpClient.post<any>(this.baseURL + 'Project/CreateOrUpdateMilestone', milestone)
  }

  updateRiskStatus(projectriskstatusId: number) {
    return this.httpClient.get<any>(this.baseURL + 'Project/UpdateProjectRiskStatus?projectriskstatusId=' + projectriskstatusId)
  }

  getLastUpdatedProjectDetailsDate(projectId: number = 0) {
    return this.httpClient.get<any>(this.baseURL + 'Project/GetLastUpdatedProjectDetailsDate?projectId=' + projectId);
  }
}